export const config = {
  key: import.meta.env.VITE_ZENDESK_WEB_WIDGET_KEY,
};
